import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './DateTimeInput.scss';

export const DateTimeInput = (props) => {
  const { className, id, label, max, min, required, defaultValue } = props;

  const classes = classNames('lanl-date-time', className);

  return (
    <div className={classes}>
      <label>{label}</label>
      <input
        key={defaultValue}
        type='date'
        id={id}
        name={id}
        required={required}
        defaultValue={defaultValue}
        min={min}
        max={max}
      />
    </div>
  );
};

DateTimeInput.defaultProps = {
  options: [],
  required: false,
};

DateTimeInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
};

export default DateTimeInput;
